import { createRoot } from "react-dom/client"
import { Provider } from "react-redux"
import { store } from "./app/store"
import "./index.css"
import { RouterProvider } from "react-router"
import router from "./app/router/router"
import './app/i18n';

// import './assets/css/animate.css'
// import './assets/css/bootstrap.css'
// import './assets/css/font-awesome.css'
// import './assets/css/fonts.css'
// import './assets/css/owl.carousel.css'
// import './assets/css/owl.theme.default.css'
// import './assets/css/magnific-popup.css'
// import './assets/css/style.css'
// import './assets/js/jquery.js'
// import './assets/js/bootstrap.js'
// import './assets/js/jquery.magnific-popup.js'
// import './assets/js/owl.carousel.js'
// import './assets/js/jquery.countTo.js'
// import './assets/js/jquery.appear.js'
// import './assets/js/custom.js'



const container = document.getElementById("root")

if (container) {
  const root = createRoot(container)

  root.render(
    // <React.StrictMode>
      <Provider store={store}>
        <RouterProvider router={router}/>
      </Provider>
    // </React.StrictMode>,
  )
} else {
  throw new Error(
    "Root element with ID 'root' was not found in the document. Ensure there is a corresponding HTML element with the ID 'root' in your HTML file.",
  )
}
